import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * "Gå til indhold": the first focusable element in each shell, hidden until it has focus
 * (WCAG 2.4.1 Bypass Blocks, #689). Its target is abook-page's `<main id="main-content">`,
 * which every page renders — so it works on every page, with or without the header.
 */
@Component({
  selector: 'abook-skip-link',
  templateUrl: './skip-link.component.html',
  styleUrl: './skip-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkipLinkComponent {
  /** abook-page's `<main>`. */
  protected readonly target = 'main-content';

  private readonly document = inject(DOCUMENT);

  /**
   * Focus from script, not the browser's fragment navigation: that would put #main-content in
   * the URL, which the router and the portal's anchor scrolling would each react to.
   */
  protected skip(event: Event): void {
    const target = this.document.getElementById(this.target);
    if (!target) return;
    event.preventDefault();
    target.focus();
  }
}
